import axios from 'axios';

// const baseUrl = 'http://192.168.1.5:9001/api';
const baseUrl = 'https://api.restoku.id/api';
// const baseUrl = process.env.API_URL + '/api';

export const getRaw = (url) => {
    return axios.get(url)
        .then(response => {
            return response.data;
        });
}

export const get = (url) => {
    return axios.get(baseUrl + url)
        .then(response => {
            return response.data;
        });
}

export const post = (url, data, config) => {
    return axios.post(baseUrl + url, data, config)
        .then(response => {
            return response.data;
        });
}

export const postJson = (url, data) => {
    const json = JSON.stringify(data);
    return axios.post(baseUrl + url, json, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(response => {
        return response.data;
    });
}


// WEBPACK FOOTER //
// ./src/api/Api.js